
export default function FormsExtensionFeatures() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'AI智能识别',
      description: '基于深度学习的表单识别技术，自动识别表单结构和字段类型，支持手写文字识别',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-database-2-line',
      title: '数据提取',
      description: '精准提取表单数据，支持结构化输出，可直接导入数据库或业务系统',
      color: 'from-cyan-500 to-teal-500'
    },
    {
      icon: 'ri-file-list-line',
      title: '多格式支持',
      description: '支持PDF、图片、扫描件等多种格式，兼容各类表单模板',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-shield-check-line',
      title: '数据验证',
      description: '内置数据验证规则，自动检查数据完整性和准确性，减少人工审核工作',
      color: 'from-cyan-500 to-teal-500'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: '易于集成',
      description: '提供RESTful API和多语言SDK，支持快速集成到现有系统',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-line-chart-line',
      title: '实时监控',
      description: '提供处理状态监控和统计分析，帮助优化业务流程',
      color: 'from-cyan-500 to-teal-500'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>核心功能特性</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            强大的<strong>表单处理能力</strong>，满足企业各类<strong>文档自动化</strong>需求
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${feature.color} mb-6`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <strong>{feature.title}</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
